import { ContentLayout } from "layouts/ContentLayout";
import { ProfitAndLoss } from "modules/financial";

const ProfitAndLossPage = () => {
  return (
    <ContentLayout title={"Profit and Loss"}>
      <ProfitAndLoss />
    </ContentLayout>
  );
};

export default ProfitAndLossPage;
